import { FC } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Box, Card } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { CustomizedText } from "../../../components/styled-componnets";
import { DD_MM_YYY, convertTo12Hour } from "../../../utils/date";

interface PreSalesSiteVisitUpdateProps {
	date?: string;
	time?: string;
	comment?: string;
}

const PreSalesSiteVisitUpdate: FC<PreSalesSiteVisitUpdateProps> = ({
	date,
	time,
	comment,
}) => {
	const { t } = useTranslation();

	return (
		<Card
			sx={{
				background: "#ffffff",
				borderRadius: "16px",
				border: "1.5px solid #e5e7eb",
				boxShadow: "0 4px 12px rgba(0, 0, 0, 0.03)",
				p: 3,
				mb: 2,
				mt: 2,
				width: "95%",
				display: "flex",
				flexDirection: "column",
			}}
		>
			{/* Header Row */}
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					width: "100%",
					mb: 3,
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
					<Box
						sx={{
							background: "#2563eb",
							borderRadius: "8px",
							width: 36,
							height: 36,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexShrink: 0,
						}}
					>
						<AssignmentIcon sx={{ color: "#fff", fontSize: 20 }} />
					</Box>
					<Box sx={{ display: "flex", flexDirection: "column" }}>
						<CustomizedText fontSize={18} fontColor="#111827" font="Lora-Bold">
							{t("opportunity_details.pre_sales_site_visit")}
						</CustomizedText>
					</Box>
				</Box>

			</Box>

			{/* Date & Time boxes side by side */}
			<Box sx={{ display: "flex", gap: 2, mb: 2 }}>
				<Box
					sx={{
						flex: 1,
						background: "#f8fafc",
						border: "1px solid #e2e8f0",
						borderRadius: "12px",
						p: 2,
					}}
				>
					<CustomizedText
						fontSize={11}
						fontColor="#6b7280"
						font="Lato-Bold"
						sx={{ letterSpacing: "0.05em", mb: 0.5, textTransform: "uppercase" }}
					>
						📅 {t("opportunity_details.site_visit_date")}
					</CustomizedText>
					<CustomizedText fontSize={18} fontColor="#111827" font="Lora-Bold">
						{moment(date).format(DD_MM_YYY)}
					</CustomizedText>
				</Box>

				<Box
					sx={{
						flex: 1,
						background: "#f8fafc",
						border: "1px solid #e2e8f0",
						borderRadius: "12px",
						p: 2,
					}}
				>
					<CustomizedText
						fontSize={11}
						fontColor="#6b7280"
						font="Lato-Bold"
						sx={{ letterSpacing: "0.05em", mb: 0.5, textTransform: "uppercase" }}
					>
						🕒 {t("opportunity_details.site_visit_time")}
					</CustomizedText>
					<CustomizedText fontSize={18} fontColor="#111827" font="Lora-Bold">
						{convertTo12Hour(time)}
					</CustomizedText>
				</Box>
			</Box>

			{/* Agent comment box */}
			{comment && (
				<Box
					sx={{
						background: "#fffbeb",
						border: "1px solid #fde68a",
						borderRadius: "12px",
						p: 2,
						mt: 1,
					}}
				>
					<CustomizedText
						fontSize={11}
						fontColor="#b45309"
						font="Lato-Bold"
						sx={{ letterSpacing: "0.05em", mb: 0.5, textTransform: "uppercase" }}
					>
						💬 {t("opportunity_details.site_visit_comment")}
					</CustomizedText>
					<CustomizedText fontSize={15} fontColor="#111827" font="Lora-Medium">
						{comment}
					</CustomizedText>
				</Box>
			)}
		</Card>
	);
};

export default PreSalesSiteVisitUpdate;
